// plugins/i18n.js
import { createI18n } from 'vue-i18n'
import { getCookie } from '@/common/utils'

const messages = {}

const i18n = createI18n({
  locale: getCookie('hk_language')?.substring(0, 2) || 'en',
  fallbackLocale: 'en',
  messages
})

export default i18n
